/** Query parameters Better Auth adds when it signs an authorization request (not part of the request itself). */
const SIGNING_PARAMS = new Set(['exp', 'sig', 'ba_iat', 'ba_param']);

/**
 * Where to go after signing in. When the login page was reached from an OAuth authorization request (an MCP client
 * such as Claude Code connecting), continue that request; otherwise honour `next` if it is a local path.
 */
export function afterLoginTarget(search: string): string {
  const q = new URLSearchParams(search);
  if (q.has('client_id') && q.has('response_type')) {
    const replay = new URLSearchParams();
    for (const [k, v] of q) if (!SIGNING_PARAMS.has(k)) replay.append(k, v);
    return `/api/auth/oauth2/authorize?${replay.toString()}`;
  }
  const next = q.get('next');
  if (next && next.startsWith('/') && !next.startsWith('//')) return next;
  return '/';
}

/** The magic-link verify URL carried by /login/confirm, accepted only on this origin. */
export function safeVerifyLink(raw: string | null, origin: string): string | null {
  if (!raw) return null;
  try {
    const u = new URL(raw, origin);
    if (u.origin !== origin || u.pathname !== '/api/auth/magic-link/verify') return null;
    return u.toString();
  } catch {
    return null;
  }
}

/** The local callback a `p2b login` run listens on (loopback only). */
export function safeCliCallback(port: string | null, state: string | null): string | null {
  if (!port || !state || !/^\d{2,5}$/.test(port) || !/^[A-Za-z0-9_-]{8,128}$/.test(state)) return null;
  const n = Number(port);
  if (n < 1024 || n > 65535) return null;
  return `http://127.0.0.1:${n}/callback`;
}
